module.exports = __webpack_public_path__ + "static/media/welcomeBg.3f53b669.jpg";